// ユーティリティ関数：要素が存在する場合のみSwiperを初期化
function initSwiper(selector, options) {
	if (document.querySelector(selector)) {
		return new Swiper(selector, options);
	}
	return null;
}

// サムネイル（mv__thumbnailが存在するページのみ）
// const swiperThumbnail = initSwiper(".mv__thumbnail", {
// 	slidesPerView: 'auto',
// 	loop: true,
// });

// トップスワイパー（swiperThumbnailがnullの場合はthumbsを渡さない）
const topswiper = initSwiper(".mv__sliderArea", {
	autoplay: {
		delay: 3000,
		disableOnInteraction: false,
	},
	effect: 'fade',
	speed: 2000,
	fadeEffect: {
		crossFade: true,
	},
	// ...(swiperThumbnail && {
	// 	thumbs: {
	// 		swiper: swiperThumbnail
	// 	},
	// }),
});

const swiper = initSwiper(".pickup__sliderArea", {
	slidesPerView: 1,
	spaceBetween: 36,
	breakpoints: {
		481: {
			slidesPerView: 2
		}
	},
	navigation: {
		nextEl: ".pickup__button--next",
		prevEl: ".pickup__button--prev",
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
});

const swiper2 = initSwiper(".strength__logoArea--slider1", {
	loop: true,
	speed: 10000,
	slidesPerView: 5,
	allowTouchMove: false,
	autoplay: {
		delay: 0
	},
	breakpoints: {
		481: {
			slidesPerView: 5.5
		}
	},
});

const swiper3 = initSwiper(".strength__logoArea--slider2", {
	loop: true,
	speed: 10000,
	slidesPerView: 5,
	allowTouchMove: false,
	autoplay: {
		delay: 0,
		reverseDirection: true,
	},
	breakpoints: {
		481: {
			slidesPerView: 5.5
		}
	},
});

const swiper4 = initSwiper(".newsletter__sliderArea", {
	slidesPerView: 1,
	spaceBetween: 30,
	breakpoints: {
		481: {
			slidesPerView: 3
		}
	},
	navigation: {
		nextEl: ".newsletter__button--next",
		prevEl: ".newsletter__button--prev",
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
});

const swiper5 = initSwiper(".hnPickup__sliderArea", {
	slidesPerView: 1,
	spaceBetween: 30,
	breakpoints: {
		481: {
			slidesPerView: 3
		}
	},
	navigation: {
		nextEl: ".hnPickup__button--next",
		prevEl: ".hnPickup__button--prev",
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
});

const swiper6 = initSwiper(".overview__sliderArea", {
	autoplay: {
		delay: 3000,
		disableOnInteraction: false,
	},
	slidesPerView: 1.2,
	spaceBetween: 10,
	centeredSlides: true,
	loop: true,
	breakpoints: {
		481: {
			slidesPerView: 2.4,
			spaceBetween: 20,
		}
	},
});

// ハンバーガーメニュー内アコーディオン
jQuery('.headerNavi__listLink--acdn').on('click', function () {
	jQuery(this).toggleClass('open');
	jQuery(this).next(".headerNavi__subList").toggleClass('open').slideToggle();
});


jQuery('.headerNavi__listItem--parent').hover(
	function () {
		jQuery(this).find('.headerNavi__pcSubList').stop(true, true).fadeIn(200);
	},
	function () {
		jQuery(this).find('.headerNavi__pcSubList').stop(true, true).fadeOut(200);
	}
);


// FAQ内アコーディオン
jQuery('.faq__dt').on('click', function () {
	jQuery(this).next(".faq__dd").toggleClass('open').slideToggle();
});
